<template>

    <script type="application/ld+json">
      {
        "@context": "http://schema.org",
        "@type": "Event",
        "name": "{{event.name}}",
        "startDate": "{{event.fecha_sesion}}",
        "eventAttendanceMode": "https://schema.org/OfflineEventAttendanceMode",
        "eventStatus": "https://schema.org/EventScheduled",
        "image": [ "{{event.imagen}}" ],
        "location": {
          "@type": "Place",
          "name": "{{event.direccion}}",
          "address": {
            "@type": "PostalAddress",
            "streetAddress": "{{event.direccion}}",
            "addressLocality": "Murcia",
            "addressCountry": "ES"
          }
        },
        "description": "{{event.name}}",
        "performer": {
          "@type": "PerformingGroup",
          "name": "{{event.name}}"
        },
        "organizer": {
          "@type": "Organization",
          "name": "{{event.author}}"
        }
      }
    </script>

</template>


<script>

export default {
    props: ['event'],
}

</script>